export default __webpack_public_path__ + "static/media/info-deep-blue-citron.733df8b2.svg";